export const externalLink = (color = 'white', size = '14') => {
	const svg = `<svg width="${size}" height="${size}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.45783 5.62719C7.21827 5.62312 7.02507 5.43503 7.0209 5.20182L7.02026 3.18485L2.51196 7.57392C2.33827 7.74302 2.05668 7.74302 1.883 7.57392C1.70931 7.40483 1.70931 7.13069 1.883 6.96159L6.39131 2.5725L4.32017 2.5725C4.07458 2.56834 3.87897 2.37116 3.88322 2.13208C3.88739 1.89884 4.08059 1.71075 4.32016 1.7067L7.4649 1.7067C7.71052 1.70641 7.9099 1.90001 7.91021 2.13912V2.14023V5.2018C7.90595 5.44091 7.70341 5.63135 7.45783 5.62719Z"
			fill="#797B7A"
		/>
	</svg>`;

	return svg;
};
